import React from 'react';
import { Ordem, PedidoDetalhe } from '../../types';
import { formatCurrency, formatDate } from '../../utils/formatters';
import './styles.css';

interface PreviewImpressaoProps {
  ordem: Ordem;
  pedidos: PedidoDetalhe[];
}

export const PreviewImpressao: React.FC<PreviewImpressaoProps> = ({ ordem, pedidos }) => {
  return (
    <div className="preview-impressao" id="preview-impressao">
      <div className="preview-impressao-content">
        {/* Cabeçalho da empresa */}
        <div className="preview-impressao-header">
          <h1 className="preview-impressao-empresa">BAGS EXCLUSIVAS</h1>
          <p className="preview-impressao-subtitulo">PERSONARE</p>
          <div className="preview-impressao-divider"></div>
        </div>

        {/* Informações da ordem */}
        <div className="preview-impressao-section">
          <h2 className="preview-impressao-title">ORDEM DE SERVIÇO #{ordem.id}</h2>
          <div className="preview-impressao-info">
            <p><strong>Data:</strong> {formatDate(ordem.data)}</p>
            {ordem.finalizado_em && (
              <p><strong>Finalizado em:</strong> {formatDate(ordem.finalizado_em)}</p>
            )}
            <p><strong>Status:</strong> {
              ordem.status === 'pendente' ? 'PENDENTE' :
              ordem.status === 'em_producao' ? 'EM PRODUÇÃO' :
              'FINALIZADO'
            }</p>
          </div>
        </div>

        {/* Lista de pedidos */}
        <div className="preview-impressao-section">
          <h3 className="preview-impressao-subtitle">PEDIDOS</h3>
          <div className="preview-impressao-divider"></div>
          {pedidos.map((pedido, index) => (
            <div key={pedido.id} className="preview-impressao-pedido">
              <div className="preview-impressao-pedido-header">
                <span className="preview-impressao-pedido-numero">PEDIDO {index + 1}</span>
                <span className={`preview-impressao-status status-${pedido.status}`}>
                  {pedido.status === 'pendente' ? 'PENDENTE' :
                   pedido.status === 'em_producao' ? 'EM PRODUÇÃO' :
                   'FINALIZADO'}
                </span>
              </div>
              
              <div className="preview-impressao-pedido-info">
                <p><strong>Modelo:</strong> {pedido.modelo_nome}</p>
                {pedido.material_nome && (
                  <p><strong>Material:</strong> {pedido.material_nome}</p>
                )}
                <p><strong>Quantidade:</strong> {pedido.quantidade}x</p>
                {pedido.cor && (
                  <p><strong>Cor:</strong> {pedido.cor}</p>
                )}
                <div className="preview-impressao-pedido-precos">
                  <p><strong>Preço Unitário:</strong> {formatCurrency(pedido.preco_inicial)}</p>
                  <p className="preview-impressao-total-pedido">
                    <strong>Total do Pedido:</strong> {formatCurrency(pedido.preco_final)}
                  </p>
                </div>
                {pedido.observacao && (
                  <div className="preview-impressao-observacao">
                    <p><strong>Observação:</strong></p>
                    <p>{pedido.observacao}</p>
                  </div>
                )}
              </div>
              
              {index < pedidos.length - 1 && (
                <div className="preview-impressao-divider-linha"></div>
              )}
            </div>
          ))}
        </div>

        {/* Rodapé com total */}
        <div className="preview-impressao-footer">
          <div className="preview-impressao-divider"></div>
          <div className="preview-impressao-total">
            <p className="preview-impressao-total-label">VALOR TOTAL DA ORDEM</p>
            <p className="preview-impressao-total-valor">{formatCurrency(ordem.valor_total)}</p>
          </div>
          <div className="preview-impressao-divider"></div>
        </div>

        {/* Informações da empresa no rodapé */}
        <div className="preview-impressao-rodape">
          <p>Obrigado pela preferência!</p>
          <p className="preview-impressao-data-impressao">
            Impresso em: {new Date().toLocaleString('pt-BR')}
          </p>
        </div>
      </div>
    </div>
  );
};

